var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"contact"},[_c('div',{staticClass:"container"},[_c('h2',{attrs:{"data-aos":"fade-right"}},[_vm._v(" Contact us today! ")]),_c('span',{attrs:{"data-aos":"zoom-in","data-aos-delay":"350"}},[_c('a',{staticClass:"button button-white",attrs:{"href":"/contact"}},[_vm._v(" Contact us ")])])])])
}]

export { render, staticRenderFns }